import { useCallback } from 'react'
import useAuthPopupState from './use-auth-popup-state'

export default function useOpenAuthPopup() {
  const [, update] = useAuthPopupState()

  return useCallback(() => {
    update(true)
  }, [update])
}
